/* eslint-disable prefer-destructuring */
import { getRegexMatches } from "../utils/CommonUtils";
import {
  TOKEN_SRC_CITY_URL,
  TOKEN_DEST_CITY_URL,
  URL_CURRENT,
  AIRLINE_BAGGAGE_TEMPLATE,
  AIRLINE_FLIGHT_SCHEDULE_TEMPLATE,
  AIRLINE_WEBCHECKIN_TEMPLATE,
  FLIGHT_INFORMATION_SYSTEM_TEMPLATE,
} from "../utils/Constants";
import { GI_TEMPLATE_CONFIG } from "../utils/GIConstants";
import { buildFlightStatusPath, isValidIntlFlightStatusCountrySlug } from "../utils/flightStatusUrl";

const getGITemplateTypeAndUrlPhrases = async (data) => {
  let dataMap = { ...data };
  const params = dataMap?.params || [];
  let urlPhrases = [];
  const isHindi = dataMap?.localeSettings?.language === "hi";
  if (/^[a-z]+[a-z-]*[a-z]+-to-[a-z]+[a-z-]*[a-z]+-flights$/.test(params[params.length - 1])) {
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z-]*[a-z]+)-to-([a-z]+[a-z-]*[a-z]+)-flights$/,
    );

    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.pageType = "routePage";

    if (dataMap?.isIntl) {
      dataMap.queryType = isHindi ? "hindi-international-flights" : "international-flights";
      dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
      const { ifGIRouteController } = await import("../utils/IfRouteController");
      dataMap = await ifGIRouteController(dataMap);
    } else {
      dataMap.queryType = isHindi ? "hindi-flights" : "flights";
      dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
      const { dfGIRouteController } = await import("../utils/DFRouteController");
      dataMap = await dfGIRouteController(dataMap);
    }
  } else if (
    /^flights-to-[a-z]+[a-z-]*[a-z]+$/.test(params[params.length - 1]) ||
    /^flights-from-[a-z]+[a-z-]*[a-z]+$/.test(params[params.length - 1])
  ) {
    const isFlightsTo = /^flights-to-[a-z]+[a-z-]*[a-z]+$/.test(params[params.length - 1]);
    dataMap.isFlightsTo = isFlightsTo;
    if (isFlightsTo) {
      if (dataMap?.isIntl) {
        dataMap.queryType = isHindi ? "hindi-international-flights-to" : "international-flights-to";
      } else {
        dataMap.queryType = isHindi ? "hindi-flights-to" : "flights-to";
      }
      urlPhrases = getRegexMatches(params[params.length - 1], /^flights-to-([a-z]+[a-z-]*[a-z]+)$/);
      dataMap.city_url_phrase = urlPhrases[0];
    } else {
      if (dataMap?.isIntl) {
        dataMap.queryType = isHindi
          ? "hindi-international-flights-from"
          : "international-flights-from";
      } else {
        dataMap.queryType = isHindi ? "hindi-flights-from" : "flights-from";
      }
      urlPhrases = getRegexMatches(
        params[params.length - 1],
        /^flights-from-([a-z]+[a-z_]*[a-z]+)$/,
      );
      dataMap.city_url_phrase = urlPhrases[0];
    }

    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.pageType = "toPage";
    const { cityControllerGI } = await import("../utils/CityControllerGI");
    dataMap = await cityControllerGI(dataMap);
  } else if (
    /^[a-z]+[a-z-]*[a-z]+-to-[a-z]+[a-z-]*[a-z]+-distance$/.test(params[params.length - 1])
  ) {
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z-]*[a-z]+)-to-([a-z]+[a-z-]*[a-z]+)-distance$/,
    );

    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.pageType = "distancePage";
    dataMap.queryType = "distance";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    const { distanceTemplateGIController } = await import("../utils/DistanceTemplateGIController");
    dataMap = await distanceTemplateGIController(dataMap);
  } else if (
    /^[a-z-]+-to-[a-z-]+-airline-schedule$/.test(
      params[params.length - 1],
    )
  ) {
    const url = params[params.length - 1];
    const urlParts = url.split("-to-");
    dataMap.src_url_phrase = urlParts[0];
    dataMap.destPart = urlParts[1];
    if (dataMap?.isIntl) {
      dataMap.queryType = isHindi
        ? "hindi-international-airline-schedule"
        : "international-airline-schedule";
      dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    } else {
      dataMap.queryType = isHindi ? "hindi-airline-schedule" : "airline-schedule";
      dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    }
    dataMap.isRouteAirlineSchedule = true;
    dataMap.pageType = "routeAirlinePage";
    const { flightRouteAirlineGIController } = await import(
      "../utils/FlightRouteAirlineControllerGI"
    );
    dataMap = await flightRouteAirlineGIController(dataMap);
  } else if (
    /^[a-z]+[a-z-]*[a-z]+-to-[a-z]+[a-z-]*[a-z]+-flight-schedule$/.test(params[params.length - 1])
  ) {
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z-]*[a-z]+)-to-([a-z]+[a-z-]*[a-z]+)-flight-schedule$/,
    );
    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    if (dataMap?.isIntl) {
      dataMap.queryType = isHindi
        ? "hindi-international-flight-schedule"
        : "international-flight-schedule";
      dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    } else {
      dataMap.queryType = isHindi ? "hindi-flight-schedule" : "flight-schedule";
      dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    }
    dataMap.pageType = "flightSchedulePageGI"; //'flightSchedulePage';
    dataMap.isFlightScheduleRoute = true;
    const { flightScheduleGIController } = await import("../utils/FlightScheduleControllerGI");
    dataMap = await flightScheduleGIController(dataMap);
  } else if (/^cheap-flights$/.test(params[params.length - 1])) {
    dataMap.queryType = "cheap-flights";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.pageType = "cityPage";
    const { cheapFlightsGIController } = await import("../utils/CheapFlightsControllerGI");
    dataMap = await cheapFlightsGIController(dataMap);
  } else if (/^student-flight-offers.htm$/.test(params[params.length - 1])) {
  dataMap.queryType = "student-flight-offers";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.isStaticPage = true;
    dataMap.pageType = "cityPage";
    const { studentFlightOffersGIController } = await import("../utils/StudentFlightOffersControllerGI");
    dataMap = await studentFlightOffersGIController(dataMap);
  } else if (/^armed-forces.htm$/.test(params[params.length - 1])) {
    dataMap.queryType = "armed-forces";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.isStaticPage = true;
    dataMap.pageType = "cityPage";
    const { armedForcesGIController } = await import("../utils/ArmedForcesControllerGI");
    dataMap = await armedForcesGIController(dataMap);
  } else if (/^senior-citizens.htm$/.test(params[params.length - 1])) {
    dataMap.queryType = "senior-citizens";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.isStaticPage = true;
    dataMap.pageType = "cityPage";
    const { seniorCitizensGIController } = await import("../utils/SeniorCitizensControllerGI");
    dataMap = await seniorCitizensGIController(dataMap);
  } else if (/^flight-pnr-status.htm$/.test(params[params.length - 1])) {
    dataMap.queryType = "flight-pnr-status";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.isStaticPage = true;
    dataMap.pageType = "cityPage";
    const { flightPnrStatusGIController } = await import("../utils/FlightPnrStatusControllerGI");
    dataMap = await flightPnrStatusGIController(dataMap);
  } else {
    if (dataMap?.isIntl && !dataMap.isAirlineRoute && !dataMap.isFlightSchedule) {
      dataMap.redirect = "international-flights/";
    } else if (!dataMap?.isIntl && !dataMap?.isAirlineRoute && !dataMap.isFlightSchedule) {
      dataMap.redirect = "flights/";
    }
  }
  if (dataMap.isFlightSchedule) {
    dataMap.queryType = "flight-schedule-routes";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;
    dataMap.pageType = "cityPage";
    const { cheapFlightsGIController } = await import("../utils/CheapFlightsControllerGI");
    dataMap = await cheapFlightsGIController(dataMap);
  } else if (
    dataMap.isAirlineRoute ||
    /^([a-z]+(-|_)?[a-z]*)-airlines\.html$/.test(params[params.length - 1])
  ) {
    dataMap.queryType = "airlines";
    dataMap.template_type = GI_TEMPLATE_CONFIG[dataMap.queryType].templateType;

    if (params && params.length == 0) {
      dataMap.redirect = "flights/";
      return dataMap;
    }

    let tempUrlPhrases = getRegexMatches(params[params.length - 1], /^([a-z]+(-|_)?[a-z]*)$/);
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+(-|_)?[a-z]*)-airlines\.html$/,
    );
    dataMap.airline_url_phrase = tempUrlPhrases?.length ? tempUrlPhrases[0] : urlPhrases[0];
    dataMap.pageType = "airlinePage";
    const { airlineTemplateGIController } = await import("../utils/AirlineTemplateControllerGI");
    dataMap = await airlineTemplateGIController(dataMap);
  }
  return dataMap;
};

export const getTemplateTypeAndUrlPhrases = async (data) => {
  let dataMap = { ...data };
  const params = dataMap?.params || [];
  let template = "";
  let urlPhrases = [];
  if (
    /^(domestic-flight-offer|international-flight-offer|flight-offers)\.html$/.test(
      params[params.length - 1],
    )
  ) {
    template = dataMap?.isIntl ? "if_offer_template" : "df_offer_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^(domestic-flight-offer|international-flight-offer|flight-offers)\.html$/,
    );
    dataMap.offerTemplate = true;
    dataMap.pageType = "offerPage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { indexOffersController } = await import("../utils/staticPageController");
    dataMap = await indexOffersController(dataMap);
    if (dataMap?.error) {
      return dataMap;
    }
  } else if (/^([a-z]+(?:[-_][a-z]+)*)-airlines\.html$/.test(params[params.length - 1])) {
    template = dataMap?.isIntl ? "if_airline_template" : "df_airline_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+(?:[-_][a-z]+)*)-airlines\.html$/,
    );
    dataMap.airline_url_phrase = urlPhrases[0];
    dataMap.pageType = "airlinePage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { airlineTemplateController } = await import("../utils/AirlineTemplateController");
    dataMap = await airlineTemplateController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-flight-tickets\.html$/.test(params[params.length - 1]) ||
    /^flights-to-[a-z]+[a-z_]*[a-z]+\.html$/.test(params[params.length - 1])
  ) {
    template = dataMap?.isIntl ? "if_city_template" : "df_city_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-flight-tickets\.html$|^flights-to-([a-z]+[a-z_]*[a-z]+)\.html$/,
    );
    dataMap.city_url_phrase = urlPhrases[0];
    dataMap.pageType = "cityPage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { cityController } = await import("../utils/CityController");
    dataMap = await cityController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-cheap-airtickets\.html$/.test(
      params[params.length - 1],
    ) ||
    /^[a-z]+[a-z_]*[a-z]+-to-[a-z]+[a-z_]*[a-z]+-flights\.html$/.test(params[params.length - 1])
  ) {
    template = dataMap?.isIntl ? "if_city_city_template" : "df_route_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-cheap-airtickets\.html$|^([a-z]+[a-z_]*[a-z]+)-to-([a-z]+[a-z_]*[a-z]+)-flights\.html$/,
    );

    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.pageType = "routePage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    if (dataMap?.isIntl) {
      const { ifRouteController } = await import("../utils/IfRouteController");
      dataMap = await ifRouteController(dataMap);
    } else {
      const { dfRouteController } = await import("../utils/DFRouteController");
      dataMap = await dfRouteController(dataMap);
    }
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-distance\.html$/.test(params[params.length - 1])
  ) {
    template = dataMap?.isIntl ? "if_distance_template" : "df_distance_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-distance\.html$/,
    );
    [dataMap[TOKEN_SRC_CITY_URL], dataMap[TOKEN_DEST_CITY_URL]] = urlPhrases;
    // dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.pageType = "distancePage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { distanceTemplateController } = await import("../utils/DistanceTemplateController");
    dataMap = await distanceTemplateController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-fare-calendar\.html$/.test(params[params.length - 1])
  ) {
    template = dataMap?.isIntl ? "if_fare_calendar_template" : "df_fare_calendar_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-fare-calendar\.html$/,
    );
    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.pageType = "fareCalendarPage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { fareCalendarController } = await import("../utils/FareCalendarController");
    dataMap = await fareCalendarController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-tickets\.html$/.test(
      params[params.length - 1],
    ) ||
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-flights\.html$/.test(
      params[params.length - 1],
    )
  ) {
    template = dataMap?.isIntl ? "if_route_airline_template" : "df_route_airline_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-tickets\.html$|^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-flights\.html$/,
    );
    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.airline_url_phrase = urlPhrases[2];
    dataMap.pageType = "routeAirlinePage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { flightRouteAirlineController } = await import("../utils/FlightRouteAirlineController");
    dataMap = await flightRouteAirlineController(dataMap);
  } else if (
    /^([a-z]+(-|_)?[a-z]*)-airlines-flight-schedule\.html$/.test(params[params.length - 1])
  ) {
    template = AIRLINE_FLIGHT_SCHEDULE_TEMPLATE;
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+(-|_)?[a-z]*)-airlines-flight-schedule\.html$/,
    );
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    // eslint-disable-next-line prefer-destructuring
    dataMap.airline_url_phrase = urlPhrases[0] || "";
    dataMap.pageType = "indexSchedulePage";

    const { airlineStaticPagesController } = await import("../utils/AirlineStaticPagesController");
    dataMap = await airlineStaticPagesController(dataMap);
  } else if (/^([a-z]+(-|_)?[a-z]*)-web-check-in\.html$/.test(params[params.length - 1])) {
    template = AIRLINE_WEBCHECKIN_TEMPLATE;
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+(-|_)?[a-z]*)-web-check-in\.html$/,
    );
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    // eslint-disable-next-line prefer-destructuring
    dataMap.airline_url_phrase = urlPhrases[0] || "";
    dataMap.pageType = "indexWebCheckinPage";

    const { airlineStaticPagesController } = await import("../utils/AirlineStaticPagesController");
    dataMap = await airlineStaticPagesController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-flight-schedule\.html$/.test(
      params[params.length - 1],
    )
  ) {
    template = dataMap?.isIntl ? "if_flight_schedule_template" : "flight_schedule_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-flight-schedule\.html$/,
    );
    dataMap.src_url_phrase = urlPhrases[0];
    dataMap.dest_url_phrase = urlPhrases[1];
    dataMap.pageType = "flightSchedulePage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { flightScheduleController } = await import("../utils/FlightScheduleController");
    dataMap = await flightScheduleController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-tickets\.html$/.test(params[params.length - 1]) ||
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-flights\.html$/.test(params[params.length - 1])
  ) {
    template = dataMap?.isIntl ? "if_city_airline_template" : "city_airline_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-tickets\.html$|^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-flights\.html$/,
    );
    dataMap.city_url_phrase = urlPhrases[0];
    dataMap.airline_url_phrase = urlPhrases[1];
    dataMap.pageType = "cityAirlinePage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { flightsCityAirlineController } = await import("../utils/FlightsCityAirlineController");
    dataMap = await flightsCityAirlineController(dataMap);
  } else if (/^flights-from-[a-z]+[a-z_]*[a-z]+\.html$/.test(params[params.length - 1])) {
    template = dataMap?.isIntl ? "if_from_template" : "df_from_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^flights-from-([a-z]+[a-z_]*[a-z]+)\.html$/,
    );
    dataMap.city_url_phrase = urlPhrases[0];
    dataMap.pageType = "fromPage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    const { flightsFromCityController } = await import("../utils/FlightsFromCityController");
    dataMap = await flightsFromCityController(dataMap);
  } else if (
    params.length >= 2 &&
    /^([a-z0-9_]+)-flight-status\.html$/.test(params[params.length - 1])
  ) {
    template = FLIGHT_INFORMATION_SYSTEM_TEMPLATE;
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}`;
    }
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z0-9_]+)-flight-status\.html$/,
    );
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    dataMap.airline_url_phrase = params[params.length - 2];
    dataMap.flight_code = urlPhrases[0] || "";
    dataMap.pageType = "flight_information_system";

    if (
      dataMap.isIntl &&
      params.length === 3 &&
      /^([a-z0-9_]+)-flight-status\.html$/i.test(params[params.length - 1])
    ) {
      const countrySeg = params[0];
      if (!isValidIntlFlightStatusCountrySlug(countrySeg)) {
        dataMap.redirect = buildFlightStatusPath({
          isIntl: true,
          airlineUrlPhrase: dataMap.airline_url_phrase,
          flightCode: dataMap.flight_code || "",
        }).replace(/^\//, "");
        return dataMap;
      }
    }

    const { flightStatusController } = await import("../utils/FlightStatusController");
    dataMap = await flightStatusController(dataMap);
  } else if (/^([a-z]+(-|_)?[a-z]*)-baggage-allowance\.html$/.test(params[params.length - 1])) {
    template = AIRLINE_BAGGAGE_TEMPLATE;
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+(-|_)?[a-z]*)-baggage-allowance\.html$/,
    );
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    // eslint-disable-next-line prefer-destructuring
    dataMap.airline_url_phrase = urlPhrases[0];
    dataMap.pageType = "indexBaggagePage";
    const { airlineStaticPagesController } = await import("../utils/AirlineStaticPagesController");
    dataMap = await airlineStaticPagesController(dataMap);
  } else if (
    /^[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+-[a-z]+[a-z_]*[a-z]+\.html$/.test(
      params[params.length - 1],
    )
  ) {
    template = dataMap?.isIntl ? "if_airport_template" : "city_airport_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)-([a-z]+[a-z_]*[a-z]+)\.html$/,
    );
    dataMap.airport_url_phrase = urlPhrases[0];
    dataMap.city_code = urlPhrases[1];
    dataMap.city_url_phrase = urlPhrases[2];
    dataMap.pageType = "cityAirportPage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { cityAirportController } = await import("../utils/CityAirportController");
    dataMap = await cityAirportController(dataMap);
  } else if (
    /^([a-z0-9_]+)-([a-z0-9_]+)-([a-z0-9_]+)-([a-z0-9_]+)\.html$/.test(params[params.length - 1])
  ) {
    template = "if_airport_template";
    urlPhrases = getRegexMatches(
      params[params.length - 1],
      /^([a-z0-9_]+)-([a-z0-9_]+)-([a-z0-9_]+)-([a-z0-9_]+)\.html$/,
    );
    dataMap.airport_url_phrase = urlPhrases[2];
    dataMap.city_code = urlPhrases[1];
    dataMap.city_url_phrase = urlPhrases[0];
    dataMap.pageType = "cityAirportPage";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    const { airportController } = await import("../utils/AirportController");
    dataMap = await airportController(dataMap);
  } else if (/^.*\.htm$/.test(params[params.length - 1])) {
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    dataMap.pageType = "staticPage";
    const { staticPageController } = await import("../utils/StaticController");
    dataMap = await staticPageController(dataMap);
  } else if (/^airlines\.html$/.test(params[params.length - 1])) {
    template = dataMap?.isIntl ? "if_airline_index_template" : "airline_index_template";
    if (template?.length > 0) {
      dataMap.template_type = `${
        dataMap?.language && dataMap?.language?.trim() !== "en" ? `${dataMap?.language}_` : ""
      }${template}${
        dataMap?.country_folder && dataMap?.country_folder?.trim() !== "india"
          ? `_${dataMap?.country_folder}`
          : ""
      }`;
    }
    urlPhrases = getRegexMatches(params[params.length - 1], new RegExp("/^airlines.html$/"));
    dataMap[URL_CURRENT] = `/${dataMap.lob}/${params.join("/")}`;
    dataMap.pageType = "airlineIndexPage";
    if (dataMap.isIntl) {
      const { ifAirlinesIndexController } = await import("../utils/IFAirlinesIndexController");
      dataMap = await ifAirlinesIndexController(dataMap);
    } else {
      const { airlineIndexController } = await import("../utils/AirlineIndexController");
      dataMap = await airlineIndexController(dataMap);
    }
  } else {
    if (dataMap?.localeSettings?.region === "IN" && dataMap?.isIntl) {
      dataMap.redirect = "international-flights/";
    } else {
      dataMap.redirect = "flights/";
    }
  }
  return dataMap;
};

export const validateAndPopulate = async (data) => {
  let dataMap = { ...data };
  if (dataMap.isGoibibo) {
    dataMap = await getGITemplateTypeAndUrlPhrases(dataMap);
  } else {
    dataMap = await getTemplateTypeAndUrlPhrases(dataMap);
  }
  if (dataMap?.error) return dataMap;
  return dataMap;
};
